import jsBridge from './utils/bridge.mjs';
import { API_CUSTOM_KEYBOARD_EVENT, EVENT_KEYBOARD_RECT_CHANGE } from './utils/constant.mjs';
import { Env } from '@voghion/fe-util';
let latestKeyboardVisible = false;
/**
 * 自定义键盘事件，开启后软键盘不再挤压 webView 区域，h5 通过键盘尺寸变化事件来适配
 * 由于移除了系统事件，所以开启后不能关闭
 * @returns
 */
export function customKeyboardEvent(params) {
    jsBridge.addEventListener(EVENT_KEYBOARD_RECT_CHANGE, (_event, _data) => {
        var _a;
        const env = Env.getInstance();
        if (env.isIOS) {
            /**
             * iOS 那边是根据 endRect.height 是否大于 0 来设置 visible 的
             * 当键盘关闭时，endRect.height 为 44，兼容处理一下
             */
            if (((_a = _data.endRect) === null || _a === void 0 ? void 0 : _a.height) < 50) {
                _data.visible = false;
            }
        }
        // iOS 不能返回 boolean 值
        _data.visible = !!_data.visible;
        const keyboardWillVisible = !latestKeyboardVisible && _data.visible;
        latestKeyboardVisible = _data.visible;
        if (keyboardWillVisible) {
            // 观察下来，最近的 iOS 版本键盘出现动画不是单个动画，所以 duration 比单个 ease-in-out 时间长，为了和系统键盘动画基本保持一致，duration 需要限制一下最大值
            _data.duration = Math.min(250, _data.duration);
        }
        params.onRectChange(_data);
    });
    // 关闭事件回调延迟
    jsBridge.disableHandlerDelay();
    return jsBridge
        .callPromise({
        minVersion: '1.1.4',
        // android 暂不支持
        androidMinVersion: '99.9.9'
    }, API_CUSTOM_KEYBOARD_EVENT, Object.assign(Object.assign({}, params), { onRectChange: EVENT_KEYBOARD_RECT_CHANGE }))
        .then((res) => {
        if (!res.error) {
            res.data.removeEventListener = () => {
                jsBridge.removeEventListener(EVENT_KEYBOARD_RECT_CHANGE);
            };
        }
        return res;
    });
}
